// sections
export const GENERAL_SETTINGS = 'general_settings'
